export const bg = "var(--seed-color-manner-temp-l1-bg)";
export const text = "var(--seed-color-manner-temp-l1-text)";